/**
 * Branding Configuration
 *
 * Change BRANDING_NAME to switch between brands:
 * - 'LearningFirst' - Disguise brand
 * - 'KnowitLearning' - Primary brand (LearningFirst)
 */

const BRANDING_NAME = 'LearningFirst' // Change to 'KnowitLearning' when conditions met

const brandingConfig = {
  LearningFirst: {
    name: 'LearningFirst',
    displayName: 'LearningFirst',
    tagline: 'AI-Powered Systematic Learning',
    logo: require('@/assets/LearningFirst_logo.png'),
    logoAlt: 'LearningFirst Logo',
    favicon: '/LearningFirst_logo.png',
    documentTitle: 'LearningFirst',
    companyName: 'KNOWIT PTE. LTD.',
    showTrademark: false,
    subtitle: null, // No subtitle for LearningFirst
  },
  KnowitLearning: {
    name: 'KnowitLearning',
    displayName: 'Knowit',
    tagline: 'Learning',
    logo: require('@/assets/Knowit_graphic_logo.png'),
    logoAlt: 'Knowit Logo',
    favicon: '/Knowit_graphic_logo.png',
    documentTitle: 'LearningFirst',
    companyName: 'KNOWIT PTE. LTD.',
    showTrademark: true,
    subtitle: 'Learning',
  }
}

const currentBranding = brandingConfig[BRANDING_NAME]

export default currentBranding
export { BRANDING_NAME, brandingConfig }
